import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { putNotice } from "../api/notice";
import { NoticePatchParams } from "../types/types";
import { useSnackbar } from "notistack";

const usePutNotice = ({
  contents,
  title,
  part,
  idx,
}: NoticePatchParams) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => putNotice({ contents, title, part, idx }),

    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["noticeDetail"] });
      navigate(-1);
      enqueueSnackbar(data.message, {
        variant: "success",
      });
      localStorage.removeItem("noticeImages");
    },
  });
  return mutation;
};

export default usePutNotice;
